import React from "react";
import 'antd/dist/antd.less'
import Router from'./components/route/router';//引入路由管理js
function App() {
  return (
      <Router />
  );
}

export default App;
